module.exports = __webpack_public_path__ + "static/converge5-516286f94b3c9b07b8fbab7328c08097.jpg";